import { MdOutlineStar, MdOutlineStarBorder } from 'react-icons/md'

import type { ReactElement } from 'react'

export interface Props {
  color?: string
  isActive: boolean
}

const FavoriteStar = ({ color, isActive }: Props): ReactElement => {
  return isActive ? <MdOutlineStar color="#fdbe4f" size={20} /> : <MdOutlineStarBorder color={color} size={20} />
}

export default FavoriteStar
